enum Columns {
    Frequency, 
    Impedance, 
    Phase
}

export default Columns;